import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Options } from 'highcharts';
import { take } from 'rxjs/operators';
import { FbTableListDashboardCardService } from '../fb-table-list-dashboard-card/fb-table-list-dashboard-card.service';
import { combineLatest } from 'rxjs';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';

NoDataToDisplay(Highcharts);

@Component({
  selector: 'app-fb-margin-growth-card',
  templateUrl: './fb-margin-growth-card.component.html',
  styleUrls: ['./fb-margin-growth-card.component.scss']
})
export class FbMarginGrowthCardComponent implements OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  highcharts = Highcharts;
  chartOptions: Options;
  chartData: any[];
  @Input() content: any;
  @Input() contentInUse: any;
  types: any[];
  recruiters: string[];
  efficiencies: number[];
  categories: any;
  data: any;
  marginGrowthCategories: string[];
  marginGrowthData: number[];
  recruiterEfficiencyCategories: string[];
  recruiterEfficiencyData: number[];
  filterArray: any[];
  months: { key: string, value: string }[] = [
    { key: 'All', value: 'ALL' },
    { key: 'January', value: 'JANUARY' },
    { key: 'February', value: 'FEBRUARY' },
    { key: 'March', value: 'MARCH' },
    { key: 'April', value: 'APRIL' },
    { key: 'May', value: 'MAY' },
    { key: 'June', value: 'JUNE' },
    { key: 'July', value: 'JULY' },
    { key: 'August', value: 'AUGUST' },
    { key: 'September', value: 'SEPTEMBER' },
    { key: 'October', value: 'OCTOBER' },
    { key: 'November', value: 'NOVEMBER' },
    { key: 'December', value: 'DECEMBER' }
  ];
  selectedMonth: string;
  years: { key: number, value: number }[] = [];
  selectedYear: number;
  configItem: any;
  private config = {
    'My Margin Growth': {
      transform: (data) => data.map(item => ({
        category: item.monthName,
        value: item.onboardCount,
      }))
    },
    "Recruiter's Efficiency": {
      transform: (data) => data.map(item => ({
        category: item.recruiterName,
        value: item.efficiency
      }))
    }
  };
  resData: any;
  completeTableList: any[];
  selectedReferenceValue: any;

  constructor(
    private fbTableListDashboardCardService: FbTableListDashboardCardService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content && this.content) {
      this.contentInUse = JSON.parse(JSON.stringify(this.content));
      this.fetchDetails();
    }
  }

  private fetchDetails(): void {
    this.configItem = this.config[this.contentInUse.title];
    if (this.configItem) {
      if (this.contentInUse.apiValue) {
        this.filterArray = Array.isArray(this.contentInUse.headerFilters) ? this.contentInUse.headerFilters.map((x: any, index: number) => {
          return {
            ...x,
            filterIndex: index
          }
        }) : null;
        if (Array.isArray(this.filterArray) && this.filterArray.length) {
          this.contentInUse.apiValue = this.generateUrl(this.contentInUse.apiValue, JSON.parse(JSON.stringify(this.filterArray)));
          if (this.filterArray.some(x => x.filterType === 'Year')) {
            const yearFilter = this.filterArray.find(x => x.filterType === 'Year');
            this.populateYears(yearFilter);
            this.selectedYear = new Date().getFullYear();
          }
          if (this.filterArray.some(x => x.filterType === 'Month')) {
            const currentMonthIndex = new Date().getMonth();
            this.selectedMonth = this.months[currentMonthIndex + 1].value;
            // this.updateTooltipMonth(this.selectedMonth);
          }
          if (this.filterArray.some(x => ['referenceLibrary'].includes(x.filterType))) {
            const refAPIReq = this.filterArray.filter(x => x.filterType === 'referenceLibrary' && x.referenceLibraryCategoryName).map(x => {
              return this.fbTableListDashboardCardService.getGroupReferenceData(x.referenceLibraryCategoryName, x.filterIndex);
            });
            if (Array.isArray(refAPIReq) && refAPIReq.length) {
              combineLatest(refAPIReq)
                .pipe(take(1))
                .subscribe((data: any[]) => {
                  data.forEach((result: any) => {
                    const filter = this.filterArray[result.index];
                    if (Array.isArray(result.data) && result.data.length) {
                      let dropDownArray = result.data.map(x => {
                        if (filter.filterType === 'referenceLibrary') {
                          return {
                            value: x.name,
                            name: x.desc
                          };
                        }
                      });
                      filter['dropDownArray'] = dropDownArray;
                      filter.selectedReferenceValue = dropDownArray[0].value;
                    }
                  });
                  this.getDetailsPostFilter();
                });
            } else {
              this.getDetailsPostFilter();
            }
          } else {
            this.getDetailsPostFilter();
          }
        } else {
          this.apiCall(this.contentInUse.apiValue);
        }
      } else {
        const tableList = this.configItem.transform([]);
        this.processData(tableList);
      }
    }
  }

  apiCall(apiValue: string) {
    this.fbTableListDashboardCardService.getDetails(apiValue)
      .pipe(take(1))
      .subscribe(data => {
        this.completeTableList = this.configItem.transform(data);
        const tableList = this.completeTableList.slice(0);
        this.processData(tableList);
      });
  }

  private processData(transformedData): void {
    this.chartData = transformedData;
    this.categories = this.chartData.map(item => item.category);
    this.data = this.chartData.map(item => parseFloat(item.value));
    this.updateChart();
  }

  getDetailsPostFilter() {
    const regexReferenceLibraryPattern = /\$[a-zA-Z]+-reference/g;
    if (!this.configItem || !this.contentInUse.apiValue || (this.contentInUse.apiValue.includes('$month') && !this.selectedMonth) || (this.contentInUse.apiValue.includes('$year') && !this.selectedYear)) {
      return;
    }
    let apiValue = this.contentInUse.apiValue;
    if (apiValue.includes('$month')) {
      apiValue = apiValue.replace('$month', this.selectedMonth);
    }
    if (apiValue.includes('$year')) {
      apiValue = apiValue.replace('$year', String(this.selectedYear));
    }
    const matches = this.contentInUse.apiValue.match(regexReferenceLibraryPattern);
    if (Array.isArray(matches) && matches.length) {
      matches.forEach((match: any) => {
        this.selectedReferenceValue = this.filterArray.find(x => x.apiVarible === match).selectedReferenceValue;
        if (this.selectedReferenceValue) {
          apiValue = apiValue.replace(match, String(this.selectedReferenceValue));
        }
      });
    }
    this.apiCall(apiValue);
  }

  populateYears(yearFilter: any): void {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - yearFilter.numberOfPastYears;
    const endYear = currentYear + yearFilter.numberOfFutureYears;

    for (let year = startYear; year <= endYear; year++) {
      this.years.push({ key: year, value: year });
    }
  }

  generateUrl(baseUrl: string, filters: any[]): string {
    let url = baseUrl;
    const sortedFilters = filters.sort((a, b) => a.apiOrder - b.apiOrder);

    sortedFilters.forEach(filter => {
      const paramName = filter.apiFilterParamName;
      const variableName = filter.apiVarible;
      if (paramName && variableName) {
        url += `/${paramName}/${variableName}`;
      }
    });

    return url;
  }


  updateChart() {
    // setTimeout(() => {
      const selectedReferenceValue = this.selectedReferenceValue;
      const content = this.content;
    this.chartOptions = {
      chart: {
        type: 'column',
        height: this.contentInUse.chartHeight
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: this.categories,
        crosshair: true,
        labels: {
          rotation: 0,
          style: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          },
          formatter: function () {
            if(content.title === 'My Margin Growth' && selectedReferenceValue === '15 days') {
            const dateStr = String(this.value);
            const dateParts = dateStr.split('-');
            const day = dateParts[0];
            let month = dateParts[1];
            month = month.substring(0, 3).toUpperCase();
            return `<span style="white-space: nowrap;">${day}</span><br/><span style="white-space: nowrap;">${month}</span>`;
            } else {
              return this.value.toString();
            }
          }
        },
        title: {
          text: ''
        }
      },
      yAxis: {
        // max: 100,
        visible: true,
        lineWidth: 1,
        gridLineWidth: 0,
        labels: {
          format: '{value}%',
          enabled: this.contentInUse.showXAxisLabel
        },
        title: {
          text: ''
        }
      },
      tooltip: {
        headerFormat: '',
        pointFormat: '<b>{point.y}</b>',
        // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        // pointFormat: '<td style="padding:0"><b>{point.y}</b></td></tr>',
        // footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{
        //name: 'Volume',
        type: 'column',
        color: '#0077a3',
        showInLegend: false,
        data: this.data
      }],
      credits: {
        enabled: false
      },
      lang: {
        noData: 'No data to display'
      }
    }
    // }, 1000);
  }

}
